/* eslint-disable padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['config']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    isBillViewer() {
      return this.hasAnyRole(this.config?.workOrderBillForm.viewerRoles);
    },
    isBillEditor() {
      return this.hasAnyRole(this.config?.workOrderBillForm.editorRoles);
    },
    isBillSubmitter() {
      return this.hasAnyRole(this.config?.workOrderBillForm.submitterRoles);
    },
    isBillApprover() {
      return this.hasAnyRole(this.config?.workOrderBillForm.approverRoles);
    },
  },
  methods: {
    hasAnyRole(roles) {
      return roles && this.memberOf?.some((item) => roles.includes(item.displayName));
    },
    isBillAddVisible() {
      return this.isBillEditor;
    },
    isBillEditVisible(bill) {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const billStatus = this.config.workOrderBillForm.submitStatus;
      switch (bill.status) {
        case billStatus.Received:
          if (this.isBillEditor) return true;
          return false;
        case billStatus.SubmittedForApproval:
          if (this.isBillEditor) return true;
          return false;
        case billStatus.SubmittedForPayment:
          if (this.isBillApprover) return true;
          return false;
        case billStatus.ApprovedForPayment:
          if (this.isBillApprover) return true;
          return false;
        default:
          return false;
      }
    },
    isBillSubmitForApprovalVisible(bill) {
      if (!this.isBillEditor) return false;
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const billStatus = this.config.workOrderBillForm.submitStatus;
      return bill.status === billStatus.Received;
    },
    isBillSubmitForPaymentVisible(bill) {
      if (!this.isBillSubmitter) return false;
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const billStatus = this.config.workOrderBillForm.submitStatus;
      return bill.status === billStatus.SubmittedForApproval;
    },
    isBillApproveVisible(bill) {
      if (!this.isBillApprover) return false;
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const billStatus = this.config.workOrderBillForm.submitStatus;
      return bill.status === billStatus.SubmittedForPayment;
    },
    isBillVoidVisible(bill) {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const billStatus = this.config.workOrderBillForm.submitStatus;
      switch (bill.status) {
        case billStatus.SubmittedForApproval:
          if (this.isBillEditor) return true;
          return false;
        case billStatus.SubmittedForPayment:
          if (this.isBillSubmitter) return true;
          if (this.isBillApprover) return true;
          return false;
        case billStatus.ApprovedForPayment:
          if (this.isBillApprover) return true;
          return false;
        default:
          return false;
      }
    },
    isBillPaidVisible(bill) {
      if (!this.isBillApprover) return false;
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const workorder = this.projectWorkorders.find((e) => e.id === bill.workOrderId);
      if (workorder.status === this.config.workOrderForm.submitStatus.Cancelled) {
        return false;
      }
      const billStatus = this.config.workOrderBillForm.submitStatus;
      return bill.status === billStatus.ApprovedForPayment;
    },
  },
};
